import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import { Icons } from '@components/common';

import styles from './Icons.module.scss';

const ExportIcon = ({ isDisabled }: { isDisabled: boolean }) => {
	const [icon, setIcon] = useState<React.ReactNode>(() => Icons.exportIconTransparent({ isDisabled }));

	const handleMouseEnter = () => {
		if (!isDisabled) setIcon(Icons.exportIcon());
	};
	const handleMouseLeave = () => setIcon(Icons.exportIconTransparent({ isDisabled }));

	useEffect(() => {
		setIcon(Icons.exportIconTransparent({ isDisabled }));
	}, [isDisabled]);

	return (
		<span
			className={cn(styles.exportIcon, {
				[styles.disabled]: isDisabled,
			})}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			{icon}
		</span>
	);
};

export default ExportIcon;
